<template>
  <div class="input" :class="{ 'euro': isOpen }">
    <input
      :type="type"
      :value="value"
      pattern="[0-9]"
      @input="$emit('input', $event.target.value)">
    <div class="suffix">{{ suffix }}</div>
  </div>

</template>

<script>
export default {
name: "vf-input",
  props: ['value', 'type', 'suffix', 'isOpen'],
  emits: ['input'],
}
</script>

<style scoped lang="scss">

/* Reset input */
input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  outline: 0;
  box-shadow: none;
  border: 0 !important;
  background: rgba(#cad4dd, .42);
  background-image: none;
  border-radius: 0;
}
/* Remove Arrows */
input::-ms-expand {
  display: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input::-ms-clear {
  display: none;
  height: 0;
  width: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

/* Custom input */
.input {
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  line-height: 3;
  overflow: hidden;
  border-radius: $input-border-radius;
  border: 1px solid $border;

  @include lg {
  }

  @include rwd(992) {
    height: 45px;
  }
}
input {
  flex: 1;
  padding: 0 .5rem;
  color: $input-text-color;
}

/* Icon */
.suffix {
  //content: '€';
  right: 0;
  padding: 0 1rem;
  color: rgba($gray, .79);
  background: rgba(#cad4dd, .42);
  display: flex;
  align-items: center;

  @include lg {
    padding-left: 0;
  }

  @include rwd(992) {
    padding: 0 1rem;
  }
}
/* Transition */
.input:hover .suffix {
  color: $secondary;
}

</style>
